import { isMoment } from 'moment'
import { isString } from 'lodash'

import { getIdOrNull } from '..'
import { API_DATE, getTimezoneLessMoment, periodIncludes } from '../momentjs'
import { ValidationFields } from '../validators'
import Clonable from './clonable'

/** @enum {string} */
export const SchoolPeriodProperties = Object.freeze({
  SCHOOL: ValidationFields.SCHOOL,
  START_DATE: ValidationFields.START_DATE,
  END_DATE: ValidationFields.END_DATE
})

export const SCHOOL_PERIOD_VALIDATORS = [
  { key: SchoolPeriodProperties.SCHOOL, validator: sp => !!getIdOrNull(sp.school) },
  { key: SchoolPeriodProperties.START_DATE, validator: sp => isMoment(sp.startDate) },
  { key: SchoolPeriodProperties.END_DATE, validator: sp => isMoment(sp.endDate) }
]

export class SchoolPeriod extends Clonable {
  constructor ({ id = -1, startDate = null, endDate = null, school = null }) {
    super()
    this.id = id
    this.startDate = isString(startDate) ? getTimezoneLessMoment(startDate) : startDate
    this.endDate = isString(endDate) ? getTimezoneLessMoment(endDate) : endDate
    this.school = school
  }

  toRequestBody () {
    return {
      id: getIdOrNull(this.id),
      school: getIdOrNull(this.school),
      startDate: getTimezoneLessMoment(this.startDate).format(API_DATE),
      endDate: getTimezoneLessMoment(this.endDate).format(API_DATE)
    }
  }

  includes (date) {
    return periodIncludes(this, date)
  }
}
